import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

/**
* This is a service for user management.
*/
@Injectable()
export class UserService {
    constructor(private requestService: ObservableRequestService) { }

    saveUser(body: Object, action: string): Observable<any> {
        let url = '';
        if (action === 'Add') {
            url = ConstantsService.USERS;
            return this.requestService.postRequest(url,
                JSON.stringify(body),
                this.requestService.getJSONContentType());
        } else {
            url = ConstantsService.USERS;
            return this.requestService.putRequest(url,
                JSON.stringify(body),
                this.requestService.getJSONContentType());
        }
    };

    getPasswordReset(loginId: string): Observable<any> {
      return this.requestService.getRequest(ConstantsService.PASSWORD_RESET + '/' + loginId);
    };
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user.service.ts